import { useState, useEffect } from "react";

import { TABPARAMNAME } from "../../../../constants/clientsDashboard";
import ClientsDashboardServices from "../../../../services/ClientsDashboardServices";
import {
  Data,
  UseGetMediatorDataProps,
  UseGetMediatorDataReturn,
  UseMediatorDataError,
} from "./useGetMediatorData-types";
import { TabParamName } from "../clients-dashboard-types";

const useGetMediatorData = ({
  mediatorCode,
  userTabsKeys,
}: UseGetMediatorDataProps): UseGetMediatorDataReturn => {
  const defaultError = {
    showError: false,
    renewal: "",
    unpaid: "",
  };
  const [previousMediatorCode, setPreviousMediatorCode] = useState<string>("");
  const [data, setData] = useState<Data | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<UseMediatorDataError>(defaultError);

  useEffect(() => {
    handleGetMediatorData();
  }, [mediatorCode]);

  const handleGetMediatorData = async () => {
    if (!error && mediatorCode === previousMediatorCode) return;

    setLoading(true);

    const commonParams = {
      loader: false,
      setLoading: () => {},
      mediatorCode,
    };

    try {
      const [renewalResponse, unpaidResponse] = await Promise.all([
        userTabsKeys.includes(TABPARAMNAME.RENOVACIONES as TabParamName)
          ? ClientsDashboardServices.getUpcomingRenewals(commonParams)
          : Promise.resolve(null),
        userTabsKeys.includes(TABPARAMNAME.IMPAGADOS as TabParamName)
          ? ClientsDashboardServices.getUnpaidInvoices(commonParams)
          : Promise.resolve(null),
      ]);

      const newError = { ...defaultError };
      const newData: Data = {};

      if (renewalResponse) {
        if (renewalResponse.ok) {
          newData.renovaciones = renewalResponse.data;
        } else {
          newError.showError = true;
          newError.renewal = renewalResponse.message;
        }
      }

      if (unpaidResponse) {
        if (unpaidResponse.ok) {
          newData.impagados = unpaidResponse.data;
        } else {
          newError.showError = true;
          newError.unpaid = unpaidResponse.message;
        }
      }

      setData(newData);
      setError(newError);
    } catch (error) {
      const errorMsg = "Se ha producido un error, vuelva a intentarlo más tarde";

      setError({
        showError: true,
        renewal: errorMsg,
        unpaid: errorMsg,
      });
    } finally {
      setPreviousMediatorCode(mediatorCode);
      setLoading(false);
    }
  };

  return {
    data,
    loading,
    error,
    handleGetMediatorData,
  };
};

export default useGetMediatorData;
